"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Option = _lib.Select.Option;
function ArcSingleSelect(props) {
  var options = props.options,
    showArrow = props.showArrow,
    placeholder = props.placeholder,
    loading = props.loading,
    dropdownStyle = props.dropdownStyle,
    displayKey = props.displayKey,
    placement = props.placement,
    onClear = props.onClear,
    onBlur = props.onBlur,
    onSearch = props.onSearch,
    status = props.status,
    _onChange = props.onChange,
    className = props.className,
    onFocus = props.onFocus,
    disabled = props.disabled,
    defaultValue = props.defaultValue,
    value = props.value,
    allowClear = props.allowClear,
    selectValue = props.selectValue;
  var keyName = displayKey ? displayKey : 'name';
  var keyValue = selectValue ? selectValue : keyName;
  return /*#__PURE__*/_react["default"].createElement(_lib.Select, {
    disabled: disabled
    // {...props}
    ,
    value: value,
    allowClear: allowClear,
    showSearch: true,
    dropdownClassName: className,
    dropdownStyle: dropdownStyle,
    style: {
      width: '100%'
    },
    placeholder: placeholder ? placeholder : '',
    onChange: function onChange(value, object) {
      return _onChange(value, object);
    },
    loading: loading,
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentNode;
    },
    onFocus: onFocus && onFocus,
    placement: placement,
    onBlur: onBlur && onBlur,
    onClear: onClear,
    status: status,
    showArrow: showArrow ? showArrow : false,
    onSearch: onSearch,
    defaultValue: defaultValue
  }, options.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(Option, _extends({}, item, {
      key: i,
      value: item[keyValue]
    }), item[keyName]);
  }));
}
var _default = ArcSingleSelect;
exports["default"] = _default;